module.exports = __webpack_public_path__ + "static/media/coins.0a0d8ad9.png";